window.addEventListener("DOMContentLoaded", function () {
	jQuery("#videoOfficeModal").on("shown.bs.modal", function (e) {
		const video = document.getElementById("videoModalVideo");
		video.play();
	});

	jQuery("#videoOfficeModal").on("hide.bs.modal", function (e) {
		const video = document.getElementById("videoModalVideo");
		video.pause();
	});
});
